import { render, staticRenderFns } from "./RoleMembers.vue?vue&type=template&id=5ee86665&scoped=true"
import script from "./RoleMembers.vue?vue&type=script&lang=ts"
export * from "./RoleMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee86665",
  null
  
)

export default component.exports